module.exports = __webpack_public_path__ + "4549a2d2d66577e077c9a020dc18451e.svg";